import Strategy from './Strategy';
export default Strategy;
